<template>
    <div class="space-y-4">
      <!-- Street 1 -->
      <div>
        <jet-label for="street1" value="Street" />
        <jet-input
          id="street1"
          type="text"
          class="mt-1 block w-full"
          v-model="localValue.street1"
          autocomplete="off"
        />
        <p
          v-if="errors && errors.street1"
          class="text-sm text-red-500"
        >
          {{ errors.street1 }}
        </p>
      </div>
  
      <!-- Street 2 -->
      <div>
        <jet-label for="street2" value="Street (Line 2)" />
        <jet-input
          id="street2"
          type="text"
          class="mt-1 block w-full"
          v-model="localValue.street2"
          autocomplete="off"
        />
        <p
          v-if="errors && errors.street2"
          class="text-sm text-red-500"
        >
          {{ errors.street2 }}
        </p>
      </div>
  
      <!-- City/State/ZIP Row -->
      <div class="grid grid-cols-12 gap-4">
        <!-- City -->
        <div class="col-span-5">
          <jet-label for="city" value="City" />
          <jet-input
            id="city"
            type="text"
            class="mt-1 block w-full"
            v-model="localValue.city"
            autocomplete="off"
          />
          <p
            v-if="errors && errors.city"
            class="text-sm text-red-500"
          >
            {{ errors.city }}
          </p>
        </div>
  
        <!-- State/Province Selection -->
        <div class="col-span-4">
          <jet-label for="state" :value="stateLabel" />
          <state-selector 
            v-if="localValue.country === 'US'" 
            v-model="localValue.state"
            class="mt-1 ml-0 shadow-sm w-max" 
          />
          <province-selector 
            v-if="localValue.country === 'CA'" 
            v-model="localValue.state"
            class="mt-1 ml-0 shadow-sm w-max" 
          />
          <p
            v-if="errors && errors.state"
            class="text-sm text-red-500"
          >
            {{ errors.state }}
          </p>
        </div>
  
        <!-- Postal Code -->
        <div class="col-span-3">
          <jet-label for="postal_code" :value="postalCodeLabel" />
          <jet-input
            id="postal_code"
            type="text"
            class="mt-1 block w-full"
            v-model="localValue.postal_code"
            autocomplete="off"
          />
          <p
            v-if="errors && errors.postal_code"
            class="text-sm text-red-500"
          >
            {{ errors.postal_code }}
          </p>
        </div>
      </div>
  
      <!-- Country Selection -->
      <div>
        <jet-label for="country" value="Country" />
        <multiselect
            v-model="countrySelected"
            :options="countryOptions"
            :searchable="false"
            label="label"
            select-label=""
            deselect-label=""
        ></multiselect>

        <p
          v-if="errors && errors.country"
          class="text-sm text-red-500"
        >
          {{ errors.country }}
        </p>
      </div>
    </div>
  </template>
  
  
<script>
import _ from 'lodash';

export default {
    name: 'AddressField',
    emits: ['update:modelValue'],
    props: {
        modelValue: {
            type: Object,
            default: () => ({})
        },
        errors: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            localValue: { },
            countrySelected: null,
            loading: true,
            countryOptions: [
                {
                    label: 'United States',
                    value: 'US'
                },
                {
                    label: 'Canada',
                    value: 'CA'
                }
            ]
        }
    },
    created() {
        if (this.modelValue) {
            this.localValue = { ...this.modelValue };
        }
        
        // Initialize countrySelected based on modelValue
        if (this.modelValue && this.modelValue.country) {
            this.countrySelected = this.countryOptions.find(option => 
                option.value === this.modelValue.country
            );
        }
    },
    mounted() {
        this.loading = false;
        //if we don't have a country selected, set it to US
        if (!this.localValue.country) {
            this.localValue.country = 'US';
            this.countrySelected = this.countryOptions[0];
        }
    },
    computed: {
        stateLabel() {
            return this.localValue.country === 'CA' ? 'Province' : 'State'
        },
        postalCodeLabel() {
            return this.localValue.country === 'CA' ? 'Postal Code' : 'ZIP Code'
        }
    },
    watch: {
        modelValue: {
            handler(newValue) {
                if (!_.isEqual(newValue, this.localValue)) {
                    //this prevents an infinite loop
                    this.localValue = { ...newValue };
                    this.countrySelected = this.countryOptions.find(option => 
                        option.value === newValue.country
                    );
                }
            },
            deep: true
        },
        localValue: {
            handler(newValue) {
                if (this.loading) {
                    return;
                }
                this.$emit('update:modelValue', newValue);
            },
            deep: true
        },
        countrySelected: {
            handler(newValue) {
                if (newValue) {
                    this.localValue.country = newValue.value;
                }
            }
        }
    }
}
</script>